import { PreviewCard, WebVideo } from '@telus-uds/components-web'
import { BlogUrl } from 'src/blogBuilder/utils/blogUrl'
import BBImage from '../../Image'

import type { IArticleFields } from '@/bb-contentful-types'

type FindHeaderValue = (category: string, publishDate: string) => string

const findHeaderValue: FindHeaderValue = (category, publishDate) => {
  if (category && publishDate) {
    return `${category} \u00B7 ${publishDate}`
  }
  return publishDate
}

type Props = {
  fullArticleUrl: string
  lang: 'en' | 'fr'
  category?: string
  article: IArticleFields
  fullBlogUrls: BlogUrl
}

const ArticleColumn = ({ article, fullArticleUrl, lang, category, fullBlogUrls }: Props) => {
  if (!article || !fullArticleUrl) {
    return null
  }

  const publishDate = new Date(article?.publishDate).toLocaleDateString(`${lang}-CA`, {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  })

  const header = findHeaderValue(category ? category : '', publishDate)
  let articleBaseUrl = fullArticleUrl
  const { intcmp } = article
  if (intcmp) {
    articleBaseUrl += `?intcmp=${intcmp}`
  }

  const url = `${fullBlogUrls?.hostName}${fullBlogUrls?.currentLang}/${articleBaseUrl}`
  const videoPreview = article?.previewVideo?.fields
  const media =
    article?.previewVideo && article?.previewVideo?.fields?.videoId
      ? {
          alt: article?.title,
          content: (
            <WebVideo
              videoId={videoPreview?.videoId}
              videoLength={videoPreview?.videoLength}
              aspectRatio="4:3"
              copy={lang}
              posterSrc={
                (videoPreview && videoPreview?.thumbnail && videoPreview?.thumbnail?.fields?.file?.url) ||
                (article.image && `https:${article?.image?.fields?.file?.url}`)
              }
              // TODO - remove onStart once it is marked optional on the component
              // eslint-disable-next-line @typescript-eslint/no-empty-function
              onStart={() => {}}
            />
          ),
        }
      : {
          alt: article?.title,
          content: (
            <BBImage
              height={article?.image?.fields?.file?.details?.image?.height}
              width={article?.image?.fields?.file?.details?.image?.width}
              src={article?.image?.fields?.file?.url}
              alt={article?.image?.fields?.description || article?.image?.fields?.title}
              removeWhiteSpace
              placeholder="blur"
              blurDataURL={article?.image?.fields?.file?.url}
            />
          ),
        }

  return (
    <PreviewCard
      testID="article-column-bb"
      href={url}
      tag={header}
      title={article.title}
      footer={article?.authors && article?.authors[0] && article?.authors[0]?.fields?.name}
      fullBleedContent={media}
    />
  )
}

export default ArticleColumn
